import Immutable from 'seamless-immutable';

import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  landingpageRequest: ['query'],
  landingpageSuccess: ['data'],
  landingpageFailed: ['error'],
});

const INITIAL_STATE = Immutable({
  error: {},
  seo: {},
  content: [],
});

const landigpageRequest = (state = INITIAL_STATE, { query }) => state.set('option', query);

const landigpageSuccess = (state = INITIAL_STATE, { data }) => state.merge(data);

const landigpageFailed = (state = INITIAL_STATE, { error }) => state.set('error', error);

export default createReducer(INITIAL_STATE, {
  [Types.LANDINGPAGE_REQUEST]: landigpageRequest,
  [Types.LANDINGPAGE_SUCCESS]: landigpageSuccess,
  [Types.LANDINGPAGE_FAILED]: landigpageFailed,
});
